import { call, put, takeLatest } from 'redux-saga/effects';

import { addendumFile, notification } from '../../actionTypes';
import dataProvider from '../../store/dataProvider';

export function* download({ payload: { companyId, fileId, tempFile, fileName } }) {
  try {
    const params = { filter: { fileName } };
    yield call(
      dataProvider.getOnly,
      `companies/${companyId}/addendum/file/${fileId}/${tempFile ? 'temp-download' : 'download'}`,
      params,
    );

    yield put({ type: addendumFile.download.end, payload: { fileId } });
  } catch (e) {
    yield put({ type: notification.add, payload: { error: e.message } });
    yield put({ type: addendumFile.download.error, payload: { fileId } });
  }
}

export default function* downloadAddendumFileSaga() {
  yield takeLatest(addendumFile.download.start, download);
}
